/* PRDGL — Shopify Online Store 2.0 behaviour.
   The Shopify cart is the single source of truth (AJAX Cart API). No fake cart.
   Config (Klaviyo, money format) is injected by theme.liquid as window.PRDGL. */
(function () {
  'use strict';
  var CFG = window.PRDGL || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var html = document.documentElement;

  /* ---------- money formatting (uses shop's money_format from Liquid) ---------- */
  function money(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    var v = (cents / 100);
    function withComma(n, dec) {
      var s = (Math.abs(n)).toFixed(dec);
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount': return withComma(v, 2);
        case 'amount_no_decimals': return withComma(v, 0);
        case 'amount_with_comma_separator': return withComma(v, 2).replace(/,/g, 'X').replace(/\./g, ',').replace(/X/g, '.');
        case 'amount_no_decimals_with_comma_separator': return withComma(v, 0).replace(/,/g, 'X').replace(/\./g, ',').replace(/X/g, '.');
        default: return withComma(v, 2);
      }
    });
  }
  /* ---------- header: wordmark to monogram, and step aside on collision ---------- */
  (function () {
    var head = document.getElementById('head');
    if (!head) return;
    var brand = head.querySelector('.brand');
    var burger = document.getElementById('burger');
    var cartBtn = document.getElementById('cart');
    var mnav = document.getElementById('mnav');
    var GUARD = 'h1,h2,h3,h4,p,li,table,button,.btn,input,.card__media,.gal,.strip,.mark,.eyebrow,.foot-col,.foot-brand';
    var guard = [];

    var collect = function () {
      var sy = window.scrollY || 0, sx = window.scrollX || 0;
      guard = [].slice.call(document.querySelectorAll(GUARD)).filter(function (el) {
        return !head.contains(el) && !el.closest('.mnav') && !el.closest('.bag') && !el.closest('#whPopup') && !el.closest('.gal-lb');
      }).map(function (el) {
        var r = el.getBoundingClientRect();
        return { top: r.top + sy, bottom: r.bottom + sy, left: r.left + sx, right: r.right + sx, w: r.width, h: r.height };
      }).filter(function (b) { return b.w || b.h; });
    };

    var clash = function (el) {
      if (!el || !guard.length) return false;
      var m = el.getBoundingClientRect(), pad = 8;
      if (!m.width && !m.height) return false;
      var sy = window.scrollY || 0, sx = window.scrollX || 0;
      var top = m.top + sy, bottom = m.bottom + sy, left = m.left + sx, right = m.right + sx;
      for (var i = 0; i < guard.length; i++) {
        var b = guard[i];
        if (b.bottom < top - pad || b.top > bottom + pad) continue;
        if (b.right < left - pad || b.left > right + pad) continue;
        return true;
      }
      return false;
    };

    var tick = false;
    var apply = function () {
      var y = window.scrollY > 60;
      head.classList.toggle('solid', y);
      head.classList.toggle('scrolled', y);
      var hide = clash(brand) || clash(burger) || clash(cartBtn);
      var open = mnav && mnav.classList.contains('on');
      head.classList.toggle('mark-off', hide);
      head.classList.toggle('burger-off', !open && hide);
      head.classList.toggle('cart-off', hide);
      tick = false;
    };

    var pending = false;
    var remeasure = function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; collect(); apply(); });
    };

    collect();
    apply();
    window.addEventListener('scroll', function () {
      if (!tick) { tick = true; requestAnimationFrame(apply); }
    }, { passive: true });
    window.addEventListener('resize', remeasure, { passive: true });
    window.addEventListener('orientationchange', remeasure);
    window.addEventListener('load', remeasure);
    document.addEventListener('transitionend', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-reveal')) remeasure();
    }, true);
    document.addEventListener('load', function (e) {
      if (e.target && e.target.tagName === 'IMG') remeasure();
    }, true);
  })();
  /* ---------- mobile menu ---------- */
  (function () {
    var burger = $('#burger'), mnav = $('#mnav');
    function menu(open) {
      if (mnav) { mnav.classList.toggle('on', open); mnav.setAttribute('aria-hidden', open ? 'false' : 'true'); }
      html.classList.toggle('menu-open', open);
      if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && mnav) { var f = mnav.querySelector('a'); if (f) f.focus(); }
    }
    if (burger) burger.addEventListener('click', function () { menu(!(mnav && mnav.classList.contains('on'))); });
    $$('[data-menuclose]').forEach(function (el) { el.addEventListener('click', function () { menu(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') menu(false); });
  })();

  /* ---------- reveal on scroll ---------- */
  (function () {
    var els = $$('[data-reveal]');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (list) {
      list.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  })();

  /* ---------- background videos: muted autoplay loop ---------- */
  (function () {
    var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    $$('video[data-bgvideo]').forEach(function (v) {
      v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; v.loop = true;
      var play = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      if (rm && rm.matches) { v.removeAttribute('autoplay'); return; }
      if (v.hasAttribute('data-inview') && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (l) { l.forEach(function (e) { e.isIntersecting ? play() : (function () { try { v.pause(); } catch (x) {} })(); }); }, { threshold: 0.2 });
        io.observe(v);
      } else { play(); }
      ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach(function (ev) {
        window.addEventListener(ev, function once() { play(); window.removeEventListener(ev, once); }, { once: true, passive: true });
      });
    });
  })();

  /* ===================== SHOPIFY BAG (AJAX cart) ===================== */
  var Bag = (function () {
    var lines = $('#bagLines'), totalEl = $('#bagTotal'), countEls = $$('[data-cart-count]');
    var panel = $('.bag__panel'), lastFocus = null;
    function open(o) {
      if (o === false) { close(); return; }
      lastFocus = document.activeElement;
      html.classList.add('bag-open');
      if (panel) panel.setAttribute('aria-hidden', 'false');
      var x = $('.bag__x'); if (x) setTimeout(function () { x.focus(); }, 40);
    }
    function close() {
      html.classList.remove('bag-open');
      if (panel) panel.setAttribute('aria-hidden', 'true');
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    }
    $$('[data-bagopen]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(true); }); });
    $$('[data-bagclose]').forEach(function (b) { b.addEventListener('click', function () { close(); }); });
    document.addEventListener('keydown', function (e) {
      if (!html.classList.contains('bag-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab' && panel) {
        var f = $$('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])', panel).filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    function render(cart) {
      if (countEls.length) countEls.forEach(function (c) { c.textContent = cart.item_count; c.classList.toggle('is-empty', cart.item_count === 0); });
      if (totalEl) totalEl.textContent = money(cart.total_price);
      if (!lines) return;
      if (!cart.items.length) {
        lines.innerHTML = '<p class="bag__empty">Your bag is empty.</p>';
        return;
      }
      lines.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
        var size = '';
        (it.options_with_values || []).forEach(function (o) { if (/size/i.test(o.name)) size = o.value; });
        return '' +
          '<div class="bag__line" data-key="' + it.key + '">' +
            '<div class="bag__thumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
            '<div class="bag__cont">' +
              '<div class="bag__row"><span class="bag__name">' + it.product_title + '</span><span class="bag__price">' + money(it.final_line_price) + '</span></div>' +
              (size ? '<div class="bag__size">Size ' + size + '</div>' : '') +
              '<div class="bag__side">' +
                '<div class="bag__qty">' +
                  '<button type="button" data-qty="dec" aria-label="Decrease quantity">&minus;</button>' +
                  '<span>' + it.quantity + '</span>' +
                  '<button type="button" data-qty="inc" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<button type="button" class="bag__rm" data-qty="rm">Remove</button>' +
              '</div>' +
            '</div>' +
          '</div>';
      }).join('');
    }

    function get() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
    function refresh() { return get().then(render); }
    function add(id, qty) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: id, quantity: qty || 1 }) })
        .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
        .then(function () { return refresh(); })
        .then(function () { open(true); });
    }
    function change(key, qty) {
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(render);
    }

    if (lines) {
      lines.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-qty]'); if (!btn) return;
        var line = btn.closest('.bag__line'); var key = line.getAttribute('data-key');
        var cur = parseInt(line.querySelector('.bag__qty span').textContent, 10) || 1;
        var op = btn.getAttribute('data-qty');
        if (op === 'inc') change(key, cur + 1);
        else if (op === 'dec') change(key, Math.max(0, cur - 1));
        else if (op === 'rm') change(key, 0);
      });
    }

    var cta = $('#bagCta');
    if (cta) cta.addEventListener('click', function () { window.location.href = '/checkout'; });

    refresh();
    return { add: add, refresh: refresh, open: open };
  })();

  /* ===================== PRODUCT PAGE ===================== */
  (function () {
    var root = $('#product'); if (!root) return;
    var variants = [];
    try { variants = JSON.parse(root.getAttribute('data-variants') || '[]'); } catch (e) {}
    var priceEl = $('#pdpPrice', root), addBtn = $('#addBtn', root), note = $('#pdpNote', root);
    var sizeBtns = $$('.pdp__size', root);
    var selected = null;

    function pick(btn) {
      sizeBtns.forEach(function (b) { b.classList.remove('sel'); });
      btn.classList.add('sel');
      var size = btn.getAttribute('data-value');
      selected = variants.filter(function (v) { return v.size === size; })[0] || null;
      if (selected) {
        if (priceEl) priceEl.textContent = money(selected.price);
        if (addBtn) {
          addBtn.disabled = !selected.available;
          addBtn.textContent = selected.available ? 'Add to Bag' : 'Sold Out';
        }
      }
      if (note) note.textContent = '';
    }
    sizeBtns.forEach(function (b) { b.addEventListener('click', function () { pick(b); }); });

    if (addBtn) addBtn.addEventListener('click', function () {
      if (!selected) { if (note) note.textContent = 'Please choose a size.'; return; }
      if (!selected.available) { if (note) note.textContent = 'That size is sold out.'; return; }
      addBtn.disabled = true; var label = addBtn.textContent; addBtn.textContent = 'Adding\u2026';
      Bag.add(selected.id, 1).then(function () { addBtn.textContent = 'Added \u2713'; setTimeout(function () { addBtn.disabled = false; addBtn.textContent = label; }, 1400); })
        .catch(function (err) { addBtn.disabled = false; addBtn.textContent = label; if (note) note.textContent = (err && err.description) || 'Could not add to bag.'; });
    });

    /* ---- media gallery: Shopify media in admin order (photos, video, guides) ---- */
    (function () {
      var gal = $('#gal', root); if (!gal) return;
      var track = $('#galTrack', gal);
      var slides = $$('.gal__slide', gal);
      if (!track || !slides.length) return;
      var dots = $$('.gal__dot', gal);
      var labelEl = $('#galLabel', gal);
      var prev = $('#galPrev', gal), next = $('#galNext', gal);
      var cur = -1;

      function pauseOthers(i) {
        slides.forEach(function (s, k) {
          if (k === i) return;
          var v = s.querySelector('video');
          if (v && !v.paused) { try { v.pause(); } catch (e) {} }
        });
      }
      function set(i) {
        if (i === cur) return;
        cur = i;
        dots.forEach(function (d, k) {
          d.classList.toggle('sel', k === i);
          d.setAttribute('aria-current', k === i ? 'true' : 'false');
        });
        if (labelEl) labelEl.textContent = slides[i].getAttribute('data-label') || '';
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
        slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
        pauseOthers(i);
      }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        set(i);
      }
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var w = track.clientWidth || 1;
          set(Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w))));
        });
      }, { passive: true });
      if (prev) prev.addEventListener('click', function () { go(cur - 1); });
      if (next) next.addEventListener('click', function () { go(cur + 1); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      gal.addEventListener('keydown', function (e) {
        if (e.target.tagName === 'VIDEO') return;
        if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      });
      window.addEventListener('resize', function () {
        if (cur >= 0) track.scrollTo({ left: slides[cur].offsetLeft, behavior: 'auto' });
      }, { passive: true });
      set(0);

      /* tap an image to view it full screen (size and care guides are detailed) */
      var lb = $('#galLb'), lbImg = $('#galLbImg'), lbClose = $('#galLbClose'), lbLast = null;
      function lbOpen(src, alt) {
        if (!lb || !lbImg) return;
        lbLast = document.activeElement;
        lbImg.src = src; lbImg.alt = alt || '';
        lb.hidden = false; html.classList.add('lb-open');
        if (lbClose) lbClose.focus();
      }
      function lbHide() {
        if (!lb) return;
        lb.hidden = true; html.classList.remove('lb-open');
        if (lbImg) lbImg.removeAttribute('src');
        if (lbLast && lbLast.focus) { try { lbLast.focus(); } catch (e) {} }
      }
      $$('[data-zoom]', gal).forEach(function (b) {
        b.addEventListener('click', function () {
          var img = b.querySelector('img');
          lbOpen(b.getAttribute('data-zoom'), img ? img.alt : '');
        });
      });
      if (lbClose) lbClose.addEventListener('click', lbHide);
      if (lb) lb.addEventListener('click', function (e) { if (e.target === lb) lbHide(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb && !lb.hidden) lbHide(); });
    })();

    /* ---- size chart cm / in toggle ---- */
    (function () {
      var wrap = $('[data-sizechart]', root); if (!wrap) return;
      $$('[data-unit]', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var unit = btn.getAttribute('data-unit');
          $$('[data-unit]', wrap).forEach(function (b) { b.classList.toggle('sel', b === btn); });
          wrap.setAttribute('data-showing', unit);
        });
      });
    })();
  })();

  /* ===================== KLAVIYO community signup (Name / Email / Mobile) ===================== */
  (function () {
    var form = $('#joinForm'); if (!form) return;
    var fName = $('#f-name'), fEmail = $('#f-email'), fMobile = $('#f-mobile');
    var name = $('#joinName'), email = $('#joinEmail'), mobile = $('#joinMobile');
    var done = $('#joinDone'), btn = form.querySelector('[type="submit"]');
    var validEmail = function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); };
    var normPhone = function (v) { var d = (v || '').replace(/[^0-9+]/g, ''); if (/^0[0-9]{9}$/.test(d)) d = '+61' + d.slice(1); return d; };
    var setBad = function (field, bad) { if (field) field.classList.toggle('bad', !!bad); };
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var nm = (name && name.value || '').trim();
      var em = (email && email.value || '').trim();
      var mob = (mobile && mobile.value || '').trim();
      var ok = true;
      setBad(fName, false); setBad(fEmail, false); setBad(fMobile, false);
      if (name && !nm) { setBad(fName, true); ok = false; }
      if (!validEmail(em)) { setBad(fEmail, true); ok = false; }
      if (mob && mob.replace(/[^0-9]/g, '').length < 8) { setBad(fMobile, true); ok = false; }
      if (!ok) { var firstBad = form.querySelector('.field.bad input'); if (firstBad) firstBad.focus(); return; }
      if (!CFG.klaviyoSiteId || !CFG.klaviyoListId) { setBad(fEmail, true); return; }
      var label = btn ? btn.textContent : ''; if (btn) { btn.disabled = true; btn.textContent = 'Sending\u2026'; }
      var phone = mob ? normPhone(mob) : null;
      var attrs = { email: em, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
      if (nm) attrs.first_name = nm;
      if (phone) { attrs.phone_number = phone; attrs.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } }; }
      var payload = { data: { type: 'subscription', attributes: { custom_source: 'PRDGL Community', profile: { data: { type: 'profile', attributes: attrs } } }, relationships: { list: { data: { type: 'list', id: CFG.klaviyoListId } } } } };
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(CFG.klaviyoSiteId), {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': CFG.klaviyoRevision || '2026-04-15' }, body: JSON.stringify(payload)
      }).then(function (r) {
        if (r.status === 202 || r.ok) { form.hidden = true; form.style.display = 'none'; if (done) done.classList.add('on'); }
        else throw new Error('status ' + r.status);
      }).catch(function () { if (btn) { btn.disabled = false; btn.textContent = label; } setBad(fEmail, true); var er = fEmail && fEmail.querySelector('.err'); if (er) er.innerHTML = 'That didn\u2019t send. Please try again, or email <a href="mailto:community@prdgl.com.au">community@prdgl.com.au</a>.'; });
    });
  })();
})();
